module.exports = __webpack_public_path__ + "media/images/chat-alex-icon-gradient-6ba4291b.svg";